import { fetchGet } from '~utilities/fetch';

export async function aggregatorsListRequest(): Promise<Response> {
    return fetchGet('/aggregators');
}
